import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { AddIndicatorDialogComponent } from './add-indicator-dialog.component';
import { IndikatorenService } from '../../../indikatoren/services/indikatoren.service';

@NgModule({
  declarations: [ AddIndicatorDialogComponent ],
  imports: [ 
    CommonModule, 
    ReactiveFormsModule, 
    MatDialogModule, 
    MatButtonModule, 
    MatFormFieldModule, 
    MatInputModule, 
    MatIconModule 
  ],
  exports: [ AddIndicatorDialogComponent ],
  providers: [ IndikatorenService ]
})
export class AddIndicatorDialogModule { }
